import React from "react";
import { ASSETS_BASE_URL } from "@/utils/constants";
import NoPersonIcon from "@public/img/no-person.png"
import { Link } from "react-router-dom";

type Props = {
    image: string;
    name: string;
    slug: string;
    type: 'directors' | 'actors';
    birth_date: string;
    birth_place: string;
    imdb_id: string;
}

export default function AgentItem({ image, name, slug, type, birth_date, birth_place, imdb_id }: Props) {
    var posterSrc = image.indexOf("http") === 0 ? image : ASSETS_BASE_URL + image.replace("files/", "");
    var photoSrc = image.length > 0 ? posterSrc : NoPersonIcon;

    return (
        <article className="agent-card">
            <div className="agent-card__photo-wrap">
                <img src={photoSrc} alt={name} className="agent-card__photo" />
            </div>
            <h2 className="agent-card__name">{name}</h2>
            <p className="agent-card__meta">تولد: {birth_date}</p>
            <p className="agent-card__meta">محل تولد: {birth_place}</p>
            <div className="agent-card__actions">
                <a href={`https://www.imdb.com/name/${imdb_id}`} target="_blank" rel="noopener noreferrer" className="agent-card__btn agent-card__btn--imdb">IMDb</a>
                <Link to={`/${type}/${slug}`} className="agent-card__btn agent-card__btn--works">همه آثار</Link>
            </div>
        </article>
    )
}
